import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { DamserviceService } from "../dam/damservice.service";
import { environment } from '../../environments/environment';
import { SubscriptionService } from "../subscription/subscription.service";
import { AuthService } from "angularx-social-login";
import { AlertService } from "../components/alert/alert.service";
import { WindowRefService } from '../services/window-ref.service';
import { OrganisationService } from "../create-organisation/organisation.service";
import { FormBuilder, Validators } from '@angular/forms';
import { GoogleLoginProvider } from "angularx-social-login";
import AOS from 'aos';

@Component({
  selector: 'app-offer-checkout',
  templateUrl: './offer-checkout.component.html',
  styleUrls: ['./offer-checkout.component.css']
})
export class OfferCheckoutComponent implements OnInit {

  title = 'Checkout - Enterprise Plan | Workspace | Crafttor';

  math = Math;

  customCheckoutSection: boolean = false;
  showLoginPage: boolean = false;
  showNotPageExist: boolean = false;
  socialLoginSection: boolean = false;
  tellUsMoreSection: boolean = false;
  createWorkspaceSection: boolean = false;
  paymentSuccessSection: boolean = false;

  workspaces = [];
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  planName: String;
  ownerEmail: String;
  ownerName: String;
  totalUsers: any;
  planId: any;
  workspaceId: any
  workspaceName: string;
  workspaceNameDynamic: string;
  userPic: any;
  userRole: string;

  radioYearly: boolean = true;
  detailsYearly: boolean = true;
  radioMonthly: boolean = false;

  checkoutToken: any;
  currentUser: User;
  strikeCheckout: any = null;
  totalPriceFixed: any;
  addUserCount: any;
  isCustomPlan: boolean = true;
  dialogId: any;

  address: string = '128 santa rosa';
  city: string = 'San Francisco';
  state: string = 'CA';
  country: string = 'US';
  postcode: string = '94014';

  finalPrice: any;
  totalWorkspace: any;
  totalSeats: any;
  totalAdmin: any;
  totalStorageSpace: any;

  totalRazorAmount: any;
  userRazorPayName: string;
  razorPayKey: string;
  orderId: any;
  couponcode: any;

  showTopRightLoader: boolean = false;
  sendSuccessfulMsg: boolean = false;
  sendSuccessfulErrorMsg: boolean = false;
  successfullMessage: string;
  sendSuccessfulErrorMessage: string;

  isShowCreateWorkspaceError: boolean = false;
  createWorkspaceErrorMessage: any;
  createWorkspaceLoginErrorMessage: string;

  login: boolean = true;
  emailVerify: boolean = false;
  signup: boolean = false;
  forgotpassword: boolean = false;
  forgotpasswordFields: boolean = false;
  enterOtp: boolean = false;
  resetPassword: boolean = false;

  submitted: Boolean = false;
  submitt: Boolean = false;
  submittedForm: Boolean = false;
  submittion: Boolean = false;
  emailVerifySubmit: Boolean = false;
  passwordSubmit: Boolean = false;
  reload: Boolean = true;
  aFormGroup: any;
  workspace_token: string;
  emailId: string;
  emailIds: string;
  forgotPasswordErrorMsg: string;
  loginErrorMsg: string;
  selectRoleTitle: string = "Founder";
  showSending: boolean = false;
  showSendingSmall: boolean = false;
  showTellUsLoader: boolean = false;
  tellUsMoreSectionErrorMsg: any;
  showTellUsMoreSectionError: boolean = false;
  signUpFormFilled: boolean = false;
  fromScreen: any;
  screenToken: any;
  showLeaveLoader: boolean = false;
  showGoogleLoginLoader: boolean = false;

  notifications = [];
  showLoader: boolean = false;
  mobileView: boolean = false;

  public lat;
  public lng;

  creatwWorkspace = this.fb.group({
    message: ['', Validators.required],
  });

  loginForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
    password: ['', Validators.required],
  });

  forgotPasswordForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
  });

  enterOtpForm = this.fb.group({
    otp: ['', Validators.required],
    password: ['', Validators.required],
    repassword: ['', Validators.required],
  });

  emailVerifyForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
  });

  signUpForm = this.fb.group({
    fname: ['', Validators.required],
    lname: ['', Validators.required],
    password: ['', Validators.required],
    otp: ['', Validators.required],
  });

  resetPasswordForm = this.fb.group({
    otp: ['', Validators.required],
    password: ['', Validators.required],
    repassword: ['', Validators.required],
  });

  enterNewDetails = this.fb.group({
    organization: [''],
    phoneNumber: [''],
    roleTitle: [''],
  });


  constructor(
    private router: Router,
    private activateRoute: ActivatedRoute,
    private titleService: Title,
    private metaTagService: Meta,
    private authenticationService: AuthenticationService,
    private damService: DamserviceService,
    private subscriptionService: SubscriptionService,
    private authService: AuthService,
    private alert: AlertService,
    private winRef: WindowRefService,
    private organisationService: OrganisationService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor digital assets management is a trendy and awesome file manager. You can store, organise and tag your assets in an attractive manner. Hurry up, sign up today!'},
      { name: 'keywords', content: 'login. workspace, login crafttor, login digital assets managment, digital assets management, dam, DAM' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }

    AOS.init();

    if(this.paymentSuccessSection == true) {
      this.showLeaveLoader = false;
      this.tellUsMoreSection = false;
      this.signUpFormFilled = false;
      this.showLoginPage = false;
      this.showNotPageExist = false;
      this.tellUsMoreSection = false;
      this.createWorkspaceSection = false;
      this.socialLoginSection = false;
      this.paymentSuccessSection = true;
      this.customCheckoutSection = false;
    }

    this.activateRoute.queryParams.subscribe(params => {
      this.checkoutToken = params['token'];
    });

    if(this.currentUser) {
      this.showLoginPage = false;
      var details = JSON.parse(localStorage.getItem('offerDialogId'));
      this.dialogId = details.dialogId;
      this.getCustomPaymentData();
      this.getWorkspaceDetails()
      this.getLocation();
      this.getUserPic();
    } else {
      this.router.navigate(['/login']);
    }

    var getTokenDetails = JSON.parse(localStorage.getItem('loginPaymentDetails'));
    this.checkoutToken = getTokenDetails.screenToken;
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        }
      },
        (error: PositionError) => console.log(error));
    } else {
      // alert("Geolocation is not supported by this browser.");
    }
  }

  showMainSection() {
    this.router.navigate(['/dam']);
  }

  getCustomPaymentData() {
    this.showTopRightLoader = true;
    this.damService.getOffersCustomPaymentData(this.dialogId).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.customCheckoutSection = true;
      this.paymentSuccessSection = false;
      this.showLoginPage = false;
      this.showNotPageExist = false;
      this.tellUsMoreSection = false;
      this.createWorkspaceSection = false;
      this.socialLoginSection = false;
      this.dialogId = data.id;
      this.finalPrice = data.amount;
      this.totalWorkspace = data.allowed_workspace_count;
      this.totalSeats = data.allowed_seats;
      this.totalAdmin = data.allowed_admin_count;
      this.totalStorageSpace = data.space;
    },(error: any) => {
      if(error.status == 400){
        this.titleService.setTitle("Link expired or page does not exist");
        this.showTopRightLoader = false;
        this.customCheckoutSection = false;
        this.paymentSuccessSection = false;
        this.showNotPageExist = true;
        this.showLoginPage = false;
        this.showTopRightLoader = false;
        this.tellUsMoreSection = false;
        this.createWorkspaceSection = false;
        this.socialLoginSection = false;
      } else {
        this.titleService.setTitle("Link expired or page does not exist");
        this.showTopRightLoader = false;
        this.paymentSuccessSection = false;
        this.customCheckoutSection = false;
        this.showNotPageExist = true;
        this.showLoginPage = false;
        this.showTopRightLoader = false;
        this.tellUsMoreSection = false;
        this.createWorkspaceSection = false;
        this.socialLoginSection = false;
      }
   });
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.listWorkspace();
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          this.workspaces = data;
          this.workspaceId = data[0].id;
          this.workspaceName = data[0].title;
          this.workspaceNameDynamic = data[0].title;
          this.userRole = data[0].role;
          this.ownerListApi(this.workspaceId);
          // this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
          //   this.boards = data;
          // });
        }else{
          this.router.navigate(['/create-workspace']);
        }
        });
      }else{
        this.router.navigate(['/login']);
      }
    }

  ownerListApi(workspaceId: any){
    this.damService.getOwnerList(workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000;
      this.consumedSpaceAllowed = data.current_dam_space/1000;
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000;
      this.totalUsers = data.allowed_seats;
      this.planId = data.plan_id;
    });
  }

  createRzpayOrder() {
    this.userRazorPayName = this.currentUser.firstName+" "+ this.currentUser.lastName;
    this.subscriptionService.getEnterpriseCustomOfferPlanRazorOrderId(this.userRazorPayName, this.finalPrice,
      this.isCustomPlan, this.addUserCount, this.couponcode, this.dialogId).subscribe((data: any) => {
      this.orderId = data.razorpay_order_id;
      this.totalRazorAmount = data.razorpay_amount;
      this.razorPayKey = data.razorpay_merchant_key;
      this.payWithRazor(this.orderId, this.razorPayKey, this.totalRazorAmount,
        this.userRazorPayName, this.finalPrice, this.addUserCount);
    },(error: any) => {
      if(error.status == 400){
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  payWithRazor(totalVal: any, key: any, totalAmount: any, userName: any,
    totalValue: any, totalSeats: any) {
    localStorage.setItem('paymentRazorDetails', JSON.stringify({ totalAmount: totalAmount}));
    const options: any = {
      key: key,
      amount: totalAmount*100,
      currency: 'USD',
      name: 'Crafttor', // company name or product name
      description: '',  // product description
      image: 'https://crafttor.com/crafttor.jpg', // company logo or product image
      order_id: totalVal, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#0c238a'
      }
    };
    options.handler = ((response, error) => {
      options.response = response;
      this.showTopRightLoader = true;
      this.subscriptionService.payEnterpriseCustomOfferPlanRazorAmountOrderId(response.razorpay_payment_id,
        response.razorpay_order_id,response.razorpay_signature, userName,
        totalValue, totalSeats, this.isCustomPlan, this.couponcode, this.dialogId).subscribe((data: any) => {
          this.showTopRightLoader = false;
          this.router.navigate(['/dam/payment-success']);
      },(error: any) => {
        if(error.status == 400){
          this.showLeaveLoader = false;
          this.tellUsMoreSection = false;
          this.signUpFormFilled = false;
          this.showLoginPage = false;
          this.showNotPageExist = false;
          this.tellUsMoreSection = false;
          this.createWorkspaceSection = false;
          this.socialLoginSection = false;
          this.paymentSuccessSection = false;
          this.customCheckoutSection = true;
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.showLeaveLoader = false;
          this.tellUsMoreSection = false;
          this.signUpFormFilled = false;
          this.showLoginPage = false;
          this.showNotPageExist = false;
          this.tellUsMoreSection = false;
          this.createWorkspaceSection = false;
          this.socialLoginSection = false;
          this.paymentSuccessSection = false;
          this.customCheckoutSection = true;
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled.');
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
    // this.hideSuccesfullFunctionMsg();
  }

  hideSuccesfullFunctionErrorDelete(){
    setTimeout(() => {
      this.sendSuccessfulErrorMsg = false;
    }, 5000);
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/login']);
  }

  selectedRoleTitle(event: any) {
    this.selectRoleTitle = event.target.value;
  }

  switchToWorkspace() {
    window.scrollTo(0, 0);
    if (this.currentUser) {
      this.router.navigate(['/dam']);
    }
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  openFigma() {
    window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
  }

  openSketch() {
    window.open("https://crafttor.com/sketch", "_blank");
  }

  openIllustrator() {
    window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
  }

  getNotifications() {
    this.showLoader = true;
    this.newNotification ();
  }

  newNotification () {
    this.damService.newNotifications(this.workspaceId).subscribe((data: any) => {
      this.notifications = data['notifcation'];
      this.showLoader = false;
    });
  }

  getName(fullEmail: string) {
    return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  personalClick(){
    this.router.navigate(['/dam/personal']);
  }

  goProClick() {
    this.router.navigate(['/dam/subscription']);
  }
}
